// extracted by mini-css-extract-plugin
export default {"noticeDiv":"Notice&Updates_noticeDiv__WuPF-","noticeHeading":"Notice&Updates_noticeHeading__VXkGj"};